import { render, staticRenderFns } from "./MonitoramentoOperacao.vue?vue&type=template&id=2b9a984f&lang=pug"
import script from "./MonitoramentoOperacao.vue?vue&type=script&lang=js"
export * from "./MonitoramentoOperacao.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoOperacao.vue?vue&type=style&index=0&id=2b9a984f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports